module.exports = __webpack_public_path__ + "2020celebration/img/s2.d55ad260.png";